export default __webpack_public_path__ + "static/media/baby-39.8795eb6f.svg";